import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import utilService from "../services/utils";

const initialState = {
  templates: [],
  key: ''
};

export const getTemplate = createAsyncThunk(
  "utils/templates",
  async () => {
    const res = await utilService.getTemplate();
    return res.data;
  }
);

export const getKey = createAsyncThunk(
  "utils/getkey",
  async () => {
    const res = await utilService.getDefaultKey();
    return res.data;
  }
);

export const setKey = createAsyncThunk(
  "utils/setkey",
  async (info) => {
    const res = await utilService.setDefaultKey(info);
    return res.data;
  }
);

const utilSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {

 },
  extraReducers: (builder) => {
    builder.addCase(getTemplate.fulfilled, (state, action) => {
      const {templates} = action.payload
      state.templates = templates || []
    })
    builder.addCase(getKey.fulfilled, (state, action) => {
      state.key = action.payload
    })
    builder.addCase(setKey.fulfilled, (state, action) => {
      state.key = action.payload
    })
  }
});

const { reducer } = utilSlice;
export default reducer;